export const IOT_DEVICE_CLEAR = 'app/iotDevice/IOT_DEVICE_CLEAR';
export const IOT_DEVICE_CLEAR_DATA = 'app/iotDevice/IOT_DEVICE_CLEAR_DATA';
export const IOT_DEVICE_CLEAR_HOLDER_DATA = 'app/iotDevice/IOT_DEVICE_CLEAR_HOLDER_DATA';
export const IOT_DEVICE_SET_DATA_FACTORY = 'app/iotDevice/IOT_DEVICE_SET_DATA_FACTORY';
export const IOT_DEVICE_SET_DEVICE_CONNECTION_STATUS = 'app/iotDevice/IOT_DEVICE_SET_DEVICE_CONNECTION_STATUS';
export const IOT_DEVICE_SET_FIRMWARE_DATA = 'app/iotDevice/IOT_DEVICE_SET_FIRMWARE_DATA';
export const IOT_DEVICE_SET_IS_PAIRING_IN_PROGRESS = 'app/iotDevice/IOT_DEVICE_SET_IS_PAIRING_IN_PROGRESS';
export const IOT_DEVICE_UPDATE_DATA = 'app/iotDevice/IOT_DEVICE_UPDATE_DATA';
export const IOT_DEVICE_REFRESH_FEATURES_CONFIG = 'app/iotDevice/IOT_DEVICE_REFRESH_FEATURES_CONFIG';
